import { ReactNode, useEffect } from 'react';
import { useAuth, useAuthTabSync } from 'iomart-hooks';

// ----------------------------------------------------------------------

type AuthProviderProps = {
  children: ReactNode;
};

function AuthProvider({ children }: AuthProviderProps) {
  const { refreshSession } = useAuth();

  useAuthTabSync();

  useEffect(() => {
    refreshSession();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {children}
    </>
  );
}

export { AuthProvider };
